module.exports = __webpack_public_path__ + "img/SSBG.f9563c4e.png";